// extracted by mini-css-extract-plugin
export default {"wrapper":"SomeoneSpecial_wrapper__ZTtXB","input_wrapper":"SomeoneSpecial_input_wrapper__QPvvk","error_msg":"SomeoneSpecial_error_msg__5l3ny"};